import React, {useRef, useEffect} from 'react';

//scss
import * as classes from './Video.module.scss'

import useWindowSize from '../../helpers/useWindowSize'

import { getFileName } from '../../helpers/FileCatching';

const Video = ({posterSrcContext, posterSrc, src, cdnBase, onImageLoad }) => {

    const [,,size] = useWindowSize();
    const videoRef = useRef();
    const posterRef = useRef()

    function imageLoaded(){
        if(onImageLoad){
            onImageLoad()
        }
    }

	function onBackgroundVideoStart(){

		videoRef.current.classList.add(classes.video__elementActive)

	}
    useEffect(() => {
        videoRef.current.addEventListener("play", onBackgroundVideoStart)
        //Hide the image to so we don't show the pre-rendered (SSR) one by mistake
        if(posterRef.current.complete){
            imageLoaded();
        }
    },[])

    useEffect(() => {

        setTimeout(() => {
            posterRef.current.style.opacity = 1;
        }, 300);

        if(posterRef.current.complete){
            imageLoaded();
        }

    },[size])



	return (
    <div className={classes.video}>
        <div className={classes.video__container}>
            <img style={{opacity:0}} ref={posterRef} onLoad={() => {imageLoaded()}} alt={"Ambient background"} className={classes.video__poster} src={getFileName(posterSrcContext, posterSrc[size]).default}></img>
            <video className={classes.video__element}  ref={videoRef} width="100%" height="50%" muted autoPlay playsInline loop>
                <source src={`${cdnBase}${src[size]}`} type="video/mp4" />
            </video>
        </div>
    </div>
	)
}


export default Video;
